import(/* webpackMode: "eager" */ "/home/runner/work/sapling/sapling/packages/foundation-intranet/src/app/(auth)/error.tsx");
